// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// COMPONENTS
/* Load components here */

// PAGE
/* load page specific scripts */

// WRITE YOUR CODE HERE
defaultBundle();
